import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';

const initialState = {
  isCreateSolutionTermsConsentPending: false,
  createConsentSuccess: false,
  isGetConsetsPending: false,
  isSaveConsentToMetaDataTablePending: false,
  savedConsent: {}
};

export const createSolutionTermsConsent = createAsyncThunk(
  'createSolutionTermsConsent',
  async ({ consentPayload, solutionId, listingVersion, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/${listingVersion}/consents`,
      {
        consent: consentPayload
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const getConsets = createAsyncThunk(
  'getConsets',
  async ({ solutionId, entityId, token }) => {
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/consents?entityId=${entityId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return {
      entityId,
      response
    };
  }
);

export const saveConsentToMetaDataTable = createAsyncThunk(
  'saveConsentToMetaDataTable',
  async ({ payload, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/consents`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const getUserDetails = createAsyncThunk(
  'getUserDetails',
  async ({ loggedInUserEmail,firstName,lastName,token}) => {
    let email =loggedInUserEmail;
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/user/role?email=${email}&firstName=${firstName}&lastName=${lastName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const appTermsSlice = createSlice({
  name: 'appTermsSlice',
  initialState,
  reducers: {
    updateConsentSuccess: (state)=>{
      state.createConsentSuccess = false
    }
  },
  extraReducers: {
    [createSolutionTermsConsent.fulfilled]: (state, action) => {
      state.isCreateSolutionTermsConsentPending = false;
      state.createConsentSuccess = true;
    },
    [createSolutionTermsConsent.pending]: state => {
      state.isCreateSolutionTermsConsentPending = true;
    },
    [createSolutionTermsConsent.rejected]: state => {
      state.isCreateSolutionTermsConsentPending = false;
    },
    [getConsets.fulfilled]: (state, action) => {
      state.isGetConsetsPending = false;
      let consent = {};
      let data = action.payload && action.payload.response && action.payload.response.data;
      for(var key in data) {
        if(key && data[key] && data[key]['consentType'] === 'solution_tnc') {
          consent = data[key];
        }
      }  
      let entityId = action.payload && action.payload.entityId;
      state.savedConsent = {
        [entityId]: consent
      };
    },
    [getConsets.pending]: state => {
      state.isGetConsetsPending = true;
    },
    [getConsets.rejected]: state => {
      state.isGetConsetsPending = false;
    },
    [saveConsentToMetaDataTable.fulfilled]: (state, action) => {
      state.isSaveConsentToMetaDataTablePending = false;
    },
    [saveConsentToMetaDataTable.pending]: state => {
      state.isSaveConsentToMetaDataTablePending = true;
    },
    [saveConsentToMetaDataTable.rejected]: state => {
      state.isSaveConsentToMetaDataTablePending = false;
    }
  }
});

export const { updateConsentSuccess } = appTermsSlice.actions;

export default appTermsSlice.reducer;